import React, { useRef, useState } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { FiMinus, FiPlus } from 'react-icons/fi';

import { ModalBasic } from '@shared/ui/modal/ModalBasic';
import { Button } from '@shared/ui/buttons/Button';

interface AvatarEditorModalProps {
  avatar: File | null;

  isVisible: boolean;

  onEdit: (avatar: Blob) => void;

  onClose: () => void;
}

export const AvatarEditorModal = (props: AvatarEditorModalProps) => {
  const editor = useRef<AvatarEditor | null>(null);
  const [scale, setScale] = useState(1.2);

  const onApprove = () => {
    if (!editor.current) {
      return;
    }

    editor.current.getImageScaledToCanvas().toBlob((blob) => {
      if (!blob) {
        return;
      }

      props.onEdit(blob);
      props.onClose();
    });
  };

  const onClose = () => props.onClose();

  return (
    <ModalBasic
      isVisible={props.isVisible}
      title="crop-avatar"
      secondaryBtnLabel="cancel"
      approveBtnLabel="confirm"
      contentClassName="flex flex-col"
      onClose={onClose}
      onApprove={onApprove}
    >
      <>
        {props.avatar && (
          <AvatarEditor
            ref={editor}
            image={props.avatar}
            width={300}
            height={300}
            style={{ width: '100%', height: '100%' }}
            border={50}
            borderRadius={150}
            color={[255, 255, 255, 0.6]}
            scale={scale}
            rotate={0}
            crossOrigin="anonymous"
          />
        )}
        <div className="flex justify-center mt-6">
          <Button
            as="button"
            type="button"
            variant="secondary"
            size="small"
            className="px-2 py-2"
            icon={FiPlus}
            iconClassName="w-7 h-auto"
            onClick={() => setScale(scale + 0.1)}
          />
          <Button
            as="button"
            type="button"
            variant="secondary"
            size="small"
            className="px-2 py-2"
            icon={FiMinus}
            iconClassName="w-7 h-auto"
            onClick={() => setScale(scale - 0.1)}
          />
        </div>
      </>
    </ModalBasic>
  );
};
